import React, { useState, useEffect } from 'react';
// eslint-disable-next-line import/no-webpack-loader-syntax
import videojs from '!video.js';
import './videojs-overlay';
import './videojs-watermark';
import 'video.js/dist/video-js.css';
import { getOS, getPlatform, isIPhone, isPossiblyIPad } from '../../services/os';
import { Capacitor } from '@capacitor/core';
import muvikaAttrs from './../../attrs';
import IosVolumeControl from './../../services/volume';
import MuvikaService from '../../services/muvika';
import TR from '../../Trans';
import { throttle } from '../../services/throttle';
import TopBarPlayer from './TopBarPlayer';
import IntervalService from '../../services/intervals';
import sessionStore from '../../stores/session';
import playerStore from '../../stores/player';
import performanceStore from '../../stores/performance';
import settingsStore from '../../stores/settings';
import statusStore from '../../stores/status';
import newTracksStore from '../../stores/newTracks';
import timeoutsStore from '../../stores/timeouts';
import musicPlayerStore from '../../stores/musicPlayer';

export const ExternalPlayer = (props) => {


  const sessionToken = sessionStore((state) => state.sessionToken);
  const getStreamUrl = playerStore((state) => state.getStreamUrl);
  const playQueue = performanceStore((state) => state.playQueue);
  const setOn = performanceStore((state) => state.setOn);
  const setIsPlaying = playerStore((state) => state.setIsPlaying);
  const setIsStopped = playerStore((state) => state.setIsStopped);
  const isPlaying = playerStore((state) => state.isPlaying);
  const empty = playerStore((state) => state.empty);
  const isStopped = playerStore((state) => state.isStopped);
  const getNextPerformance = performanceStore((state) => state.getNextPerformance);
  //const currentTime = playerStore((state) => state.currentTime);
  const setCurrentTime = playerStore((state) => state.setCurrentTime);
  const setFullScreen = playerStore((state) => state.setFullScreen);
  const streamUrl = playerStore((state) => state.streamUrl);
  const isOn = performanceStore((state) => state.isOn);
  const setPlayIsOn = performanceStore((state) => state.setPlayIsOn);
  const currentTrack = playerStore((state) => state.currentTrack);
  const deletePerformance = performanceStore((state) => state.deletePerformance);
  const addPerformanceToHistory = performanceStore((state) => state.addPerformanceToHistory);
  const currentPerformance = performanceStore((state) => state.currentPerformance);
  const countdown = performanceStore((state) => state.countdown);
  const setCountdown = performanceStore((state) => state.setCountdown);
  const nextPerformance = performanceStore((state) => state.nextPerformance);
  const setNextPerformance = performanceStore((state) => state.setNextPerformance);
  const setCurrentPerformance = performanceStore((state) => state.setCurrentPerformance);
  const currentPerformanceId = playerStore((state) => state.currentPerformanceId);
  const currentPitch = playerStore((state) => state.currentPitch);
  const currentVersion = playerStore((state) => state.currentVersion);
  const setCurrentPitch = playerStore((state) => state.setCurrentPitch);
  const setCurrentVersion = playerStore((state) => state.setCurrentVersion);
  const isInExternalWindow = playerStore((state) => state.isInExternalWindow);
  const setIsInExternalWindow = playerStore((state) => state.setIsInExternalWindow);
  const isPlayListOn = performanceStore((state) => state.isOn);
  const isFullScreen = playerStore((state) => state.isFullScreen);
  const from = playerStore((state) => state.from);
  const setVolume = playerStore((state) => state.setVolume);
  const currentVolume = playerStore((state) => state.currentVolume);
  const trackEnded = playerStore((state) => state.trackEnded);
  const isAutoPlayOn = playerStore((state) => state.isAutoPlayOn);
  const setIsAutoPlayOn = playerStore((state) => state.setIsAutoPlayOn);
  const settings = settingsStore((state) => state.settings);
  const getSettings = settingsStore((state) => state.getSettings);
  const isTrackLogSent = playerStore((state) => state.isTrackLogSent);
  const setIsTrackLogSent = playerStore((state) => state.setIsTrackLogSent);
  const isFirstRender = playerStore((state) => state.isFirstRender);
  const setIsFirstRender = playerStore((state) => state.setIsFirstRender);
  const setAppStatus = statusStore((state) => state.setAppStatus);
  const setPlayerStatus = statusStore((state) => state.setPlayerStatus);
  const setIsBuffering = playerStore((state) => state.setIsBuffering);
  const isBuffering = playerStore((state) => state.isBuffering);
  const isSwitching = playerStore((state) => state.isSwitching);
  const setIsReady = playerStore((state) => state.setIsReady);
  const isMusicReallyPaused = musicPlayerStore((state) => state.isMusicReallyPaused);

  const videoRef = React.useRef(null);
  const playerRef = React.useRef(null);
  const options = props.options;

  let pausedPosition = 0;

  const showHomeUse = () => {
    if (timeoutsStore.getState().overlayShowHomeUse) {
      clearTimeout(timeoutsStore.getState().overlayShowHomeUse);
    }
    let timerSecs = (Math.floor(Math.random() * 200) + 60) * 1000;
    //console.log("timerSecs: " + timerSecs);
    let timer = setTimeout(function () {
      const player = playerRef.current;
      if (player) {
        player.trigger("hide_title");
        player.trigger("show_home_use_desc");
        hideHomeUse();
      }
    }, timerSecs);
    timeoutsStore.getState().setOverlayShowHomeUse(timer);
  };

  const hideHomeUse = () => {
    if (timeoutsStore.getState().overlayHideHomeUse) {
      clearTimeout(timeoutsStore.getState().overlayHideHomeUse);
    }
    let timer = setTimeout(function () {
      const player = playerRef.current;
      if (player) {
        player.trigger("show_title");
        player.trigger("hide_home_use_desc");
        showHomeUse();
      }
    }, 5000);
    timeoutsStore.getState().setOverlayHideHomeUse(timer);
  };

  const showPoster = (player) => {


    let posters = player.el().getElementsByClassName("vjs-poster");
    if (posters.length == 1) {
      posters[0].classList.remove("vjs-hidden");
      posters[0].innerHTML = "";
      posters[0].style.display = "block";
    }
  };

  const hidePoster = (player) => {


    let posters = player.el().getElementsByClassName("vjs-poster");
    if (posters.length == 1) {
      posters[0].style.display = "none";
    }
  };

  const setPlayerVolume = (volume) => {
    const player = playerRef.current;
    if (player) {
      if (Capacitor.isNativePlatform() && Capacitor.getPlatform() === 'ios') {
        IosVolumeControl.setDeviceVolume(volume);
      } else {
        player.volume(volume);
      }
    }
  };

  const getPlayerVolume = () => {
    const player = playerRef.current;
    if (player) {
      if (Capacitor.isNativePlatform() && Capacitor.getPlatform() === 'ios') {
        return IosVolumeControl.getDeviceVolume();
      } else {
        return player.volume();
      }
    }
  };

  const initPlayer = () => {
    const videoElement = document.createElement("video-js");

    videoElement.classList.add('video-js');
    videoRef.current.appendChild(videoElement);
    const player = playerRef.current = videojs(videoElement, options, () => {
    });

    player.aspectRatio("16:9");
    setPlayerVolume(currentVolume.currentVolume);
    player.bigPlayButton.hide();
    player.controlBar.removeChild(player.controlBar.getChild('PictureInPictureToggle'));
    showPoster(player);
    if (muvikaAttrs.service === "muvika") {
      player.watermark({
        image: "./muvika-logo-gray-20.png",
        position: "top-left",
        xpos: 0,
        ypos: 0,
        xrepeat: 0,
        opacity: 100,
        clickable: false,
        className: 'vjs-watermark'
      });
    }

    if (props.isCustomer) {
      showHomeUse();
    }

    player.on('playing', function () {
      if ((isIPhone() || isPossiblyIPad()) && !Capacitor.isNativePlatform()) {
        setPlayerVolume(1);
      } else {
        setPlayerVolume(playerStore.getState().currentVolume.currentVolume);
      }
      playerStore.getState().setIsSwitching(false);
      playerStore.getState().setIsReady(true);
      hidePoster(player);
      player.trigger("hide_title");
    });

    player.on('loadstart', function () {
      if (!playerStore.getState().isBuffering.isBuffering) {
        console.log("loadstart");
        setIsBuffering(true);
      }
    });

    player.on('canplay', function () {
      if (playerStore.getState().isBuffering.isBuffering) {
        console.log("canplay");
        setIsBuffering(false);
      }
    });

    player.on(['pause'], function () {
      console.log("isPaused");
      playerStore.getState().setIsReady(true);
      playerStore.getState().setIsSwitching(false);
      setPlayerStatus(sessionToken, "paused");
      player.trigger("show_title");
    });

    player.fill(true);

    player.playsinline(true);
    player.reset();
  };
  useEffect(() => {
    if (!playerRef.current) {
      initPlayer();
      initExternalOverlay();
      checkPlayQueue();
    } else {
    }
  });

  const checkPlayQueue = () => {
    if (playQueue) {
      const player = playerRef.current;
      if (player) {
        if (playQueue.items.length == 0) {
          player.trigger("playqueue_empty");
          player.trigger("hide_title");
          player.trigger("hide_home_use_desc");
          clearInterval(timeoutsStore.getState().overlayShowHomeUse);
          clearInterval(timeoutsStore.getState().overlayHideHomeUse);
        } else {
          player.trigger("playqueue_populated");
          if (props.isCustomer) {
            showHomeUse();
          }
        }
      }
    }
  };

  useEffect(() => {
    checkPlayQueue();
  }, [playQueue]);

  /*   useEffect(() => {
      const player = playerRef.current;
      if (player) {
        if (Math.abs(player.currentTime() - currentTime) > 0.5) {
          player.currentTime(currentTime);
        }
      }
    }, [currentTime]); */


  const initExternalOverlay = () => {
    const player = playerRef.current;
    if (player) {
      player.overlay({
        overlays: [{
          content: '<div class="home_use_only_overlay external">' + TR.cm_karaoke_for_home_use_only + '</div>',
          start: 'show_home_use_desc',
          end: 'hide_home_use_desc',
          align: 'top',
          showBackground: false
        }]
      });
    }
  };

  useEffect(() => {
    const player = playerRef.current;
    if (player) {
      playerStore.getState().setIsSwitching(false);
      playerStore.getState().setIsReady(true);
      if (currentPerformance) {
        initExternalOverlay();
        if (currentPerformanceId) {
          if (currentPerformanceId != currentPerformance.unique_id) {
            player.currentTime(playerStore.getState().currentTime);
          }
        } else {
          player.currentTime(playerStore.getState().currentTime);
        }
        player.trigger("show_title");
      } else {
        playerStore.getState().softReset();
        showPoster(player);
      }
    }
  }, [currentPerformance]);

  useEffect(() => {
    const player = playerRef.current;
    if (player) {
      if (streamUrl !== "") {
        player.src(streamUrl);
        player.currentTime(playerStore.getState().currentTime);
        player.off('timeupdate');
        player.on('timeupdate', throttle(function () {
          setCurrentTime(player.currentTime());
        }, 500));
      } else {
        player.src();
      }
    }
  }, [streamUrl]);


  useEffect(() => {
    const player = playerRef.current;
    if (player) {
      if (isPlaying.isPlaying && !isSwitching) {
        if (isMusicReallyPaused.isPaused) {
          setIsReady(true);
          player.play();
        }
      } else {
        setIsReady(true);
        player.pause();
      }
    }
  }, [isPlaying]);

  useEffect(() => {
    const player = playerRef.current;
    if (player) {
      console.log("isPlayingPlayer", isMusicReallyPaused.isPaused);
      if (isPlaying.isPlaying && !isSwitching && isMusicReallyPaused.isPaused) {
        player.play();
      }
    }
  }, [isMusicReallyPaused]);

  useEffect(() => {
    const player = playerRef.current;
    if (player) {
      player.currentTime(from.from);
    }
  }, [from]);

  useEffect(() => {
    const player = playerRef.current;
    if (player) {
      if (!currentVolume.doNotPropagate) {
        setPlayerVolume(currentVolume.currentVolume);
      }
    }
  }, [currentVolume]);

  useEffect(() => {
    const player = playerRef.current;
    if (player) {
      playerStore.getState().setIsSwitching(false);
      playerStore.getState().setIsReady(true);
      if (isStopped.isStopped) {
        playerStore.getState().setIsTrackLogSent(null);
        showPoster(player);
        player.trigger("stop");
        setPlayerStatus(sessionToken, "stopped");
      } else {
        hidePoster(player);
      }
    }
  }, [isStopped]);

  return (
    <div style={props.style} data-vjs-player>
      <div ref={videoRef} />
    </div>
  );
};

export default ExternalPlayer;